<div class="cv-inline-sketch compact" *ngIf="selectedSketch && selectedSketch.length > 0">
    <div class="sketch-body"
         *ngFor="let image of selectedSketch; let index = index">
        <div class="floating-sketch-container">
            <div class="sketch-info">
                <span class="level-name">{{image['levelName']}}</span>
            </div>
            <div class="level-status" [ngClass]="{'selected-section': selectedSectionPath === image['refJsonPath']}">
                <span>Current Level</span>
            </div>
        </div>
        <div class="sketch-gallery-container">
            <ng-container>
                <input class="input-chk-selected-sketch"
                       [checked]="isSketchSelected(image)"
                       (change)="onCheckSketch($event, image)"
                       type="checkbox" name="sketch-{{image.id}}">
                <cv-invision-photo-card
                        [info]="image"
                        (openGallery)="openGallery($event)">
                </cv-invision-photo-card>
            </ng-container>
        </div>
    </div>
</div>
